/**
 * Deduplicate an array of objects by the given key.
 *
 * @param  array  The source array
 * @param  key    The object property to enforce uniqueness on
 * @returns       A new array with unique items (last‑wins)
 */
export function getUniqueArray<T extends Record<string, unknown>, K extends keyof T>(array: T[], key: K): T[] {
  // Map<keyValue, object>
  const map = new Map<T[K], T>();

  for (const item of array) {
    map.set(item[key], item); // overwrite → keeps the last one
  }

  return Array.from(map.values());
}
